{
  "collect": "Collect Specimen",
  "track": "Track Specimen",
  "accession": "Accession Number",
  "barcode": "Barcode",
  "status": {
    "ordered": "Ordered",
    "collected": "Collected",
    "inTransit": "In Transit",
    "received": "Received",
    "processing": "Processing",
    "resulted": "Resulted",
    "rejected": "Rejected",
    "in_transit": "In Transit"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
